import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularFireModule } from '@angular/fire';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { environment } from '../environments/environment';
import { OrderModule } from 'ngx-order-pipe';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgxLoadingModule } from 'ngx-loading';
import { AngularFirestoreModule } from '@angular/fire/firestore';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule.enablePersistence(),
    AngularFireStorageModule,
    OrderModule,
    SlickCarouselModule,
    NgxLoadingModule.forRoot({
      fullScreenBackdrop: true
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
